import {
    FETCH_PG_CONFIG_REQUEST,
    FETCH_PG_CONFIG_SUCCESS,
    FETCH_PG_CONFIG_ERROR,
    SAVE_PG_DETAIL_REQUEST,
    SAVE_PG_DETAIL_SUCCESS,
    SAVE_PG_DETAIL_ERROR,
    UPDATE_PG_REQUEST,
    UPDATE_PG_SUCCESS,
    UPDATE_PG_ERROR,
    UPDATE_PG_STATUS_REQUEST,
    UPDATE_PG_STATUS_SUCCESS,
    UPDATE_PG_STATUS_ERROR,
    RESET_SAVED_PGS,
} from './pgConfig.constants';

export const fetchPgConfigRequest = () => ({
    type: FETCH_PG_CONFIG_REQUEST,
});

export const fetchPgConfigSuccess = payload => ({
    type: FETCH_PG_CONFIG_SUCCESS,
    payload,
});

export const fetchPgConfigError = payload => ({
    type: FETCH_PG_CONFIG_ERROR,
    payload,
});

export const savePgDetailsRequest = payload => ({
    type: SAVE_PG_DETAIL_REQUEST,
    payload,
});

export const savePgDetailsSuccess = payload => ({
    type: SAVE_PG_DETAIL_SUCCESS,
    payload,
});

export const savePgDetailsError = payload => ({
    type: SAVE_PG_DETAIL_ERROR,
    payload,
});

export const updatePgsRequest = (payload, initialValues) => ({
    type: UPDATE_PG_REQUEST,
    payload,
    initialValues,
});

export const updatePgsSuccess = (payload, initialValues) => ({
    type: UPDATE_PG_SUCCESS,
    payload,
    initialValues,
});

export const updatePgsError = payload => ({
    type: UPDATE_PG_ERROR,
    payload,
});

export const updatePgStatusRequest = payload => ({
    type: UPDATE_PG_STATUS_REQUEST,
    payload,
});

export const updatePgStatusSuccess = payload => ({
    type: UPDATE_PG_STATUS_SUCCESS,
    payload,
});

export const updatePgStatusError = payload => ({
    type: UPDATE_PG_STATUS_ERROR,
    payload,
});

export const resetSavedPgs = payload => ({
    type: RESET_SAVED_PGS,
    payload,
});
